/**
 * IMPORTS
 */

import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY, USER } from "@/common/const/key-storage";

const TokenStorage = {
  async getAccessToken() {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },

  async getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  async getUserData() {
    try {
      const user = localStorage.getItem(USER);
      return user ? JSON.parse(user) : null;
    } catch {
      return null;
    }
  },

  async setUserData(user: string) {
    localStorage.setItem(USER, user);
  },

  async setTokens(access?: string | null, refresh?: string | null) {
    if (access != null) localStorage.setItem(ACCESS_TOKEN_KEY, access);

    if (refresh != null) localStorage.setItem(REFRESH_TOKEN_KEY, refresh);
  },

  async clear() {
    localStorage.removeItem(USER);
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  },
};

/**
 * EXPORTS
 */
export { TokenStorage };
